import React, { Component } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import Icon from '@mui/material/Icon';

class PaymentResult extends Component {

  state = {
    open: true
  };


  componentDidMount() {
    //  window.setTimeout(() => window.open("http://amplia.co.tt/payment-portal/"), 5000)
    //  ;
  }

  handleTryAgain = () => {

    window.history.back();
  };

  




  render() {
    return (
      <div>
        < AppBar position="fixed"
          style={
            {
              marginLeft: 260,
              backgroundColor: "#55565A"
            }
          } >
          <Toolbar>
            <Typography variant="h5" style={{ marginLeft: 260 }}>
              Payment Result
          </Typography>
          </Toolbar>
        </AppBar>
        <Paper position="fixed" align="center" style={{
          marginTop: 100,
          paddingTop: 30,
          paddingBotom: 100,
          //height: 80,
          //width: "100%",
          marginLeft: 300,
          marginRight: 40,
          paddingLeft: 150,
          paddingRight: 150,
          //margin: "auto"
        }}>
        {this.props.paymentResult.transactionSuccess?
            <div>
            <Icon style={{ color: 'rgba(71,237,62,1)',fontSize: 100 }}>check</Icon>
            <Typography variant="h6" style={{ marginTop: 10, color: 'rgba(71,237,62,1)' }}>
                <b>Your transaction was processed succesfully</b>
            </Typography>
            <Typography variant="h6" style={{ marginTop: 30}}>
                You paid ${this.props.paymentResult.amount} for {this.props.paymentResult.crmnumber}. An email will be delivered shortly confirming that your payment was received.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 30}}>
                A receipt will be delivered via email within 48hs. upon processing of your payment.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 30}}>
                If you have not received an email confirmation, please verify  that the correct email or an email address is on file for your account by contacting 800-HOME(4663)
            </Typography>
            <Typography variant="h6" style={{ marginTop: 30, paddingBottom: 60}}>
                <b>FAC reference # {this.props.paymentResult.reference}</b>
            </Typography>
        </div>
        :
        <div>
        <Icon style={{ color: 'rgba(255,204,0,1)',fontSize: 100 }}>warning</Icon>
        <Typography variant="h6" style={{ marginTop: 10 }}>
            <b>{this.props.paymentResult.facError === "Connection Lost"? "Connection Lost": "Your transaction was  unsuccesful"}</b>
        </Typography>
        <Typography variant="h6" style={{ marginTop: 30}}>
        {this.props.paymentResult.facError === "Connection Lost"? "Please contact our support at 800-HOME to verify your transaction status": "Please try again or contact your card provider if issue persist"}
        </Typography>
        <Typography variant="h6" style={{ marginTop: 30}}>
        {this.props.paymentResult.facError === "Connection Lost"? "": this.props.paymentResult.facError}
        </Typography>
        <Typography variant="h6" style={{ marginTop: 30, paddingBottom: 30}}>
            <b>{this.props.paymentResult.facError === "Connection Lost"? "": "FAC reference #: "+this.props.paymentResult.reference}</b>
        </Typography>
        <Button variant="contained" color="primary"
                onClick={this.handleTryAgain}
                style={
                  {
                    background: '#47ED3E',
                    fontWeight: 'bold',
                    borderRadius: 5,
                    border: 0,
                    color: '#55565A',
                    height: 40,
                    padding: '0 30px',
                    width: 200,
                    marginBottom: 50,
                    //marginLeft: 50,
                    //marginRight: 'auto',
                    marginTop: 20,
                    align: 'center'
                  }}
                >
                  Try Again
                </Button> 
        </div>
        }
          
          </Paper>

      </div>
    )

  }
}
export default PaymentResult